import Seo from '../components/common/utils/seo';
import type { GetStaticProps, NextPage } from 'next';
import { getHomepageData } from '../api/homepageQueries';
import { Homepage, Qrcode } from '@/typings/types';
import QrCodeWrapper from '@/components/qrcode';
import { getQrcodeData } from '../api/qrcodeQueries';

type IPageProps = {
  homepage: Homepage;
  qrcode: Qrcode;
};

const Home: NextPage<IPageProps> = ({ homepage, qrcode }) => {
  return (
    <main>
      {homepage?.seo && <Seo seo={homepage?.seo} />}
      <QrCodeWrapper homepage={homepage} qrcode={qrcode} />
    </main>
  );
};

export default Home;

export const getStaticProps: GetStaticProps = async () => {
  const { homepage } = await getHomepageData();
  const { qrcode } = await getQrcodeData();
  return {
    props: {
      homepage: homepage?.data?.attributes,
      qrcode: qrcode?.data?.attributes,
    },
    revalidate: 1,
  };
};
